import React from 'react';
import { connect } from 'react-redux';
import { PayPalScriptProvider, } from "@paypal/react-paypal-js";
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter as Router } from 'connected-react-router';

import 'antd/dist/antd.min.css';

import {
  Spin,
  notification,
} from 'antd';
import { withTranslation } from 'react-i18next';

// Redux
import { history } from 'store';
import { toggleMessage, setUp, setTheme } from 'modules/ui/actions';

// Utils
import { fetchFreshTranslations } from 'i18n';
import { get } from 'library/endpoints';

// components
import PrivateRoute from 'containers/PrivateRoute';

// Layout
import Layout from 'components/Layout';

// Screens
import Home from 'screens/Home';
import Configurator from 'screens/Configurator';
import Orders from 'screens/Orders';
import User from 'screens/User';
import Auth from 'screens/Auth';
import QuotationBasket from 'screens/QuotationBasket';
import MountQuotations from 'screens/MountQuotations';
import Helpdesk from 'screens/Helpdesk';
import Giftcard from 'screens/Giftcard';
import Franchise from 'screens/Auth/screens/Franchise';
import Autologin from 'screens/Auth/screens/Autologin';

const userLang = navigator.language || navigator.userLanguage;

/**
 * App
 */
class App extends React.PureComponent {
  state = {
    paypalClientID: null,
    theme: null,
    navigation: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        authed: true,
        exact: false,
      },
      {
        path: '/configurator',
        name: 'Configurator',
        component: Configurator,
        authed: true,
        exact: false,
      },
      {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        authed: true,
        exact: false,
      },

      {
        path: '/',
        name: 'Auth',
        component: Auth,
        authed: false,
        exact: false,
      },
      {
        path: '/auth-franchise',
        name: 'Auth',
        component: Franchise,
        authed: false,
        exact: false,
      },
      {
        path: '/autologin/:autologintoken',
        name: 'Autologin',
        component: Autologin,
        authed: false,
        exact: false,
      },
      {
        path: '/user',
        name: 'User',
        component: User,
        authed: true,
        exact: false,
      },
      {
        path: '/quotations',
        name: 'Quotations',
        component: QuotationBasket,
        authed: true,
        exact: false,
      },
      {
        path: '/mount-quotations',
        name: 'MountQuotations',
        component: MountQuotations,
        authed: true,
        exact: false,
      },
      {
        path: '/helpdesk',
        name: 'Helpdesk',
        component: Helpdesk,
        authed: true,
        exact: false,
      },
      {
        path: '/giftcard',
        name: 'Giftcard',
        component: Giftcard,
        authed: false,
        exact: false,
      },
      
    ],
  }

  async componentDidMount() {
    await this.fetchTheme();

    if (this.props.auth.user && this.props.auth.user.language) {
      fetchFreshTranslations(this.props.auth.user.language)
    } else {
      fetchFreshTranslations(userLang.length > 2 ? userLang.substring(0, 2) : userLang)
    }
  }

  componentDidUpdate() {
    if (this.props.ui.displayMessage === true) {
      notification[this.props.ui.messageType]({
        message: this.props.ui.messageContent,
        placement: 'bottomRight'
      });
      // reset message
      this.props.toggleMessage({
        display: false,
      })
    }
  }

  renderRoutes = () => {
    return this.state.navigation.map((route, i) => {
      return route.authed ? <PrivateRoute key={`route-${i}-${route.name}`} exact={route.exact} path={route.path} component={route.component} /> :
        <Route key={`route-${i}-${route.name}`} exact={route.exact} path={route.path} component={route.component} />
    })
  }

  fetchTheme = async () => {
    try {
      const response = await get('/frontend/theme')      
      this.props.setTheme({...response.data.theme, paypalClientId: response.data.clientID || 'none' })
      this.setState({
        paypalClientID: response.data.clientID || 'none',
        theme: response.data.theme
      })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    if (!this.state.paypalClientID && !this.state.theme) {
      return <Spin />
    }

    if ((!this.state.paypalClientID || this.state.paypalClientID === 'none') && this.state.theme) {
      return (
        <Router history={history}>
          <Switch>
            <Layout theme={this.state.theme}>
              {this.renderRoutes()}
            </Layout>
          </Switch>
        </Router>
      )
    }

    return (
      <PayPalScriptProvider options={{ clientId: this.state.paypalClientID, currency: 'EUR' }}>
        <Router history={history}>
          <Switch>
            <Layout theme={this.state.theme}>
              {this.renderRoutes()}
            </Layout>
          </Switch>
        </Router>
      </PayPalScriptProvider>
    );
  }
}

const stateToProps = state => ({
  ui: state.ui,
  auth: state.auth,
});

const dispatchToProps = {
  toggleMessage,
  setUp,
  setTheme
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(App));
